export default {
  items: [
    {
      id: "pages",
      title: "",
      type: "group",
      icon: "icon-pages",
      children: [
        {
          id: "clientes-status",
          title: "STATUS CLIENTES",
          type: "item",
          url: "/monitoramento/clientes-status",
          classes: "nav-item",
          icon: "fas fa-users",
        },
        {
          id: "menu-level",
          title: "CADASTROS",
          type: "collapse",
          icon: "fas fa-file-alt",
          children: [
            {
              id: "empresas",
              title: "EMPRESAS",
              type: "item",
              url: "/cadastros/empresas",
              classes: "nav-item",
              icon: "fas fa-store",
            },
          ],
        },
      ],
    },
  ],
};
